import {useAnalytics, useMetrics, useReports} from '@sail/observability';
import {useMemo} from 'react';

import type {ObservabilityFns} from 'src/internal/shared/observability/types';

export default function useObservabilityFns(): ObservabilityFns {
  const analytics = useAnalytics();
  const metrics = useMetrics();
  const reports = useReports();

  const observabilityFns = useMemo(() => {
    return {
      analytics,
      metrics,
      errors: reports,
    };
  }, [analytics, metrics, reports]);

  return observabilityFns;
}
